import { CardHeader } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/CardHeader";
import { EventBadges } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/EventBadges";
import { InternalMessageBox } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/InternalMessageBox";
import { TrainEventCardProps } from "features/CenterContent/RoleContent/EventHandling/components/eventCard/types";
import { useEventSeenStatus } from "features/CenterContent/RoleContent/EventHandling/components/eventCard/useEventSeenStatus";
import { EventCardShell } from "features/CenterContent/RoleContent/EventHandling/components/shared/EventCardShell";
import { useInternalMessagesByUuids } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useInternalMessages";
import { FC } from "react";
import { Text } from "shared/components/Spor";

const TrainEventCard: FC<TrainEventCardProps> = ({
  event,
  columnEventState,
}) => {
  useEventSeenStatus(event.uuid, event.version);

  const internalMessagesByUuid = useInternalMessagesByUuids([event.uuid]);
  const internalMessages = internalMessagesByUuid[event.uuid];

  return (
    <EventCardShell
      event={event}
      columnEventState={columnEventState}
      eventTitle={event.trainIdentifier?.identifier || ""}
    >
      {({
        colorScheme,
        semantics,
        notifying,
        canToggleNotify,
        onToggleNotify,
      }) => (
        <>
          <CardHeader
            title={
              <>
                <b>{event.trainIdentifier?.identifier ?? "-"}</b>{" "}
                {event.lineNumber ?? "-"}
              </>
            }
            colorScheme={colorScheme}
            semantics={semantics}
            notifying={notifying}
            onToggleNotify={onToggleNotify}
            showNotifyButton={canToggleNotify}
          />

          <EventBadges
            eventType={event.type.type}
            eventLabel={event.type.label ?? event.type.type}
            state={event.state}
          />

          {event.action?.description?.NOB && (
            <Text
              variant="sm"
              color={colorScheme.textColorSecondary}
              fontWeight="normal"
            >
              {event.action.description.NOB}
            </Text>
          )}

          <InternalMessageBox
            messages={internalMessages || []}
            semantics={semantics}
            colorScheme={colorScheme}
          />
        </>
      )}
    </EventCardShell>
  );
};

export default TrainEventCard;
